<template>
  <div class="gs-section">
    <div class="gs-section__toolbar">
      <div class="gs-segmented" role="group" aria-label="Article type">
        <button
          v-for="group in groups"
          :key="group.value"
          type="button"
          class="gs-segmented__item"
          :class="{ 'is-current': currentGroup === group.value }"
          :aria-pressed="currentGroup === group.value ? 'true' : 'false'"
          :data-group="group.value"
          @click="selectGroup(group.value)"
        >
          {{ group.title }}
        </button>
      </div>
      <p v-if="items.length" class="gs-section__count">{{ countLabel }}</p>
    </div>

    <div v-if="items.length" class="gs-asset-grid gs-asset-grid--wide">
      <asset-card
        v-for="item in items"
        :key="`${currentGroup}-${item.id}`"
        collapsible
        :title="item.name"
      >
        <template slot="preview">
          <pre class="gs-asset-text">{{ item.body }}</pre>
        </template>
        <template slot="actions">
          <copy-button
            :text="item.body"
            :label="copyLabel"
            :title="copyTitle"
          />
        </template>
      </asset-card>
    </div>

    <div v-else class="gs-empty">
      <span class="gs-empty__icon"><gs-icon name="list-ul" size="22" /></span>
      <p class="gs-empty__title">{{ emptyTitle }}</p>
      <p class="gs-empty__text">
        Long-form copy you can publish under your own name shows up here.
      </p>
    </div>
  </div>
</template>

<script>
import AssetCard from '@/components/promotools/AssetCard.vue';
import CopyButton from '@/components/promotools/CopyButton.vue';

export default {
  components: {
    AssetCard,
    CopyButton,
  },
  props: {
    funnelResource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentGroup: 'articles',
    };
  },
  computed: {
    groups() {
      return [
        { title: this.$t('frontend_resources_articles'), value: 'articles' },
        { title: this.$t('frontend_resources_press_releases'), value: 'pressReleases' },
      ];
    },
    isArticles() {
      return this.currentGroup === 'articles';
    },
    // Both groups are "a name and a block of copy", so they render through one
    // card list rather than two near-identical templates.
    items() {
      if (this.isArticles) {
        return this.enabled(this.funnelResource.articles)
          .map(article => ({ id: article.id, name: article.name, body: article.article }));
      }

      return this.enabled(this.funnelResource.press_releases)
        .map(release => ({ id: release.id, name: release.name, body: release.press_release }));
    },
    countLabel() {
      const count = this.items.length;

      if (this.isArticles) {
        return `${count} ${count === 1 ? 'article' : 'articles'}`;
      }

      return `${count} ${count === 1 ? 'press release' : 'press releases'}`;
    },
    copyLabel() {
      return this.isArticles ? 'Copy article' : 'Copy press release';
    },
    copyTitle() {
      return this.isArticles
        ? this.$t('frontend_groovesell_copy_article')
        : this.$t('frontend_resources_copy_press_release');
    },
    emptyTitle() {
      return this.isArticles
        ? this.$t('frontend_resources_no_articles_added_in_this')
        : this.$t('frontend_resources_no_press_release');
    },
  },
  methods: {
    enabled(list) {
      return (list || []).filter(item => item.enabled);
    },
    selectGroup(value) {
      this.currentGroup = value;
    },
  },
};
</script>
